export const MODULE_NAME = '@pressreader/analytics_core';
